import React from 'react';
import { useTranslation } from 'react-i18next';

const PackInformationForm = ({ name, description, onChange, disabled }) => {
  const { t } = useTranslation();
  const inputStyle =
    'w-full bg-white dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-600 rounded-lg px-4 py-2 shadow-sm focus:border-primary focus:ring-2 focus:ring-primary/50 transition';

  return (
    <div className="flex flex-col gap-4">
      <div>
        <label
          htmlFor="name"
          className="block font-semibold mb-2 text-neutral-800 dark:text-neutral-200"
        >
          {t('packs.create_modal.information_form.name_label')}{' '}
          <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={name}
          onChange={onChange}
          placeholder={t(
            'packs.create_modal.information_form.name_placeholder'
          )}
          className={inputStyle}
          required
          disabled={disabled}
        />
      </div>
      <div>
        <label
          htmlFor="description"
          className="block font-semibold mb-2 text-neutral-800 dark:text-neutral-200"
        >
          {t('packs.create_modal.information_form.description_label')}
        </label>
        <textarea
          id="description"
          name="description"
          value={description}
          onChange={onChange}
          placeholder={t(
            'packs.create_modal.information_form.description_placeholder'
          )}
          className={`${inputStyle} resize-y`}
          rows="3"
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default PackInformationForm;
